var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRightIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#96999E",
    d: "M8.3333 15.8334q-.3385 0-.599-.2343-.2343-.2606-.2343-.599 0-.3386.2344-.599l4.4271-4.401-4.4271-4.401Q7.5 5.3385 7.5 5q0-.3386.2344-.599.2604-.2343.599-.2343.3384 0 .599.2343l4.9999 5q.2344.2605.2344.599t-.2344.599l-5 5q-.2604.2342-.599.2343"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRightIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-right-icon.ed636bf30158606ef23e23c4415bc673.svg";